import React, { FC } from 'react';
import styled from 'styled-components';
import { noop } from 'lodash';

import { H1 } from '@ad-scripts/presentation/components/common/headers';
import customerProfileDefResource from 'src/actions/customer/customerProfileDefResource';
import useDocumentResource from 'src/presentation/hooks/useDocumentResource';
import Table from 'src/presentation/components/pages/shared/Table';
import { TR } from '@ad-scripts/presentation/components/common/table';

export const CustomAttributesContainer: FC = () => {
  const { value: profileDef } = useDocumentResource(customerProfileDefResource, { fetch: true });

  const tableItems = profileDef?.attributes;

  tableItems?.map(item => (item.id = `${item.attr}`));

  return (
    <CustomAttributeLayout data-aid="custom-atttribtues-layout">
      <CustomAttrHeaderSection>
        <H1>Custom Attributes</H1>
        <PStyled>
          Custom attributes can be configured to display on customer profile cards. They can be read-only, editable, or
          hidden. Custom attributes are added automatically when you install an App (like Shopify), or manually by the
          Gladly team for your Custom App.
        </PStyled>
      </CustomAttrHeaderSection>
      <CustomAttributesTable>
        <StyledTable
          dataAid="custom-attr-table"
          columnConfig={[
            { attr: 'attr', label: 'Key' },
            { attr: 'label', label: 'Label' },
          ]}
          items={tableItems}
          isLoading={false}
          renderRowActions={noop}
        />
      </CustomAttributesTable>
    </CustomAttributeLayout>
  );
};

export default CustomAttributesContainer;

const CustomAttributeLayout = styled.div`
  width: 827px;
  margin-top: 42px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const CustomAttrHeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const CustomAttributesTable = styled.div`
  width: 481px;
`;

const PStyled = styled.p`
  margin-top: 4px;
  margin-bottom: 20px;
  color: ${p => p.theme.colors.gray700};
  text-align: center;
`;

const StyledTable = styled(Table)`
  ${TR}:nth-child(odd) {
    background: ${p => p.theme.colors.white};
  }
`;
